<cx-messaging
  [messageEvents$]="messageEvents$"
  [messagingConfigs]="messagingConfigs"
  (send)="onSend($event)"
  (downloadAttachment)="downloadAttachment($event)"
></cx-messaging>
